<template>
	<div class="page-birthday">
		<div class="box-login">
			<h3 :style="{ color: parceiroConfigCorSecundariaCorPrimaria }">Entrar</h3>
			<p>
				{{ mensagemEmbaixoDoTitulo }}
			</p>

			<form-fields :fields="fields" @save="next" @update:values="inputsValues = $event"></form-fields>

			<div style="display: flex; flex-direction: column;">
				<label>CPF/CNPJ</label>
				<the-mask v-model="identification" pattern="[0-9]{14}" inputmode="numeric"
					:mask="['###.###.###-##', '##.###.###/####-##']"></the-mask>
			</div>

			<div id="userAgreement">
				<input v-model="agreement" type="checkbox">

				<span>Estou ciente de que meus dados serão tratados com o objetivo de renegociar minha dívida junto a
					Unimed. Quaisquer dúvidas sobre o tratamento de dados, devo acessar a <a
						href="https://mercobran.com.br/politica-de-privacidade" target="_blank">Política de
						Privacidade</a>
					ou entrar em contato com o DPO da Unimed a qual estou vinculado</span>
			</div>

			<div class="box-buttons">
				<vue-recaptcha sitekey="6LdRBcgmAAAAALxVkfRewtghl2S0y4HcilWej9Ti" class="vue-recaptcha"
					:loadRecaptchaScript="true" @verify="verified = true"></vue-recaptcha>

				<button-default :disable="!verified || !agreement" :color="corPrimaria" @click.native="next"
					text="Entrar" />

				<button-default v-if="esqueceuTelefone" :color="corPrimaria" @click.native="esqueceu"
					text="Esqueceu o seu telefone?"></button-default>
			</div>
		</div>
	</div>
</template>

<script>
	import VueRecaptcha from "vue-recaptcha";
	import { mapActions, mapMutations, mapState, createNamespacedHelpers } from "vuex";
	import globalMethods from "@/mixins/globalMethods";
	import mixins from "@/mixins/mixins";

	import FormFields from "@/components/FormFields";
	import ButtonDefault from "@/components/buttons/ButtonDefault";
	import { TheMask } from 'vue-the-mask';

	const {
		mapActions: mapActionsPassosRetornarDividas,
		mapMutations: mapMutationsPassosRetornarDividas
	} = createNamespacedHelpers("passosRetornarDividas");

	export default {
		name: "ConfirmBirthday",

		components: { ButtonDefault, FormFields, VueRecaptcha, TheMask },

		mixins: [globalMethods, mixins],

		data() {
			return {
				fields: [],
				identification: "",
				agreement: false,
				inputsValues: {},
				verified: false
			};
		},

		computed: {
			...mapState({
				pessoa: (estado) => estado.passosRetornarDividas.pessoa,
				token: (estado) => estado.token,
				lojas: (estado) => estado.passosRetornarDividas.lojas
			}),

			mensagemEmbaixoDoTitulo() {
				return this.parceiroConfig.sessoes.customization == undefined ||
					this.parceiroConfig.sessoes.customization.campos.confirmBirthday == undefined ||
					this.parceiroConfig.sessoes.customization.campos.confirmBirthday.flgValidarDataNasc ||
					this.parceiroConfig.sessoes.customization.campos.confirmBirthday.flgValidarTelefone ? "Confirme os seus dados para fazer seu login." : "Confirme que você não é um robô para fazer seu login.";
			},

			esqueceuTelefone() {
				return this.parceiroConfig.sessoes.customization == undefined ||
					this.parceiroConfig.sessoes.customization.campos.confirmBirthday == undefined ||
					this.parceiroConfig.sessoes.customization.campos.confirmBirthday.flgEsqueceuTelefone;
			},

			chaveRecaptchaPortal() {
				return this.parceiroConfig.identificador === "aqui" ? "6Lf-sxAmAAAAAEAMKT4BGuREXmINn4jlC-jxpcbX" : "6LcT3ZYaAAAAAFAwpV9WcdSbZUyuiEx9cC8xoF71";
			}
		},

		created() {
			if (this.$route.params.identification) {
				this.identification = this.$route.params.identification;
				this.phoneNumber = this.$route.params.phoneNumber;
			} else {
				this.$router.push({ name: "LandPageParceiro" });
			}
		},

		mounted() {
			this.fields = [];
			if (this.parceiroConfig.sessoes?.customization == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday == undefined ||
				this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarDataNasc) {

				var campoDN = {
					variableName: "nascimento",
					fieldType: "DateField",
					label: "Data nascimento",
					type: "text",
					cols: "12",
					required: true,
					plusEighteen: true
				};
				this.fields.push(campoDN);
			}
			if (this.parceiroConfig.sessoes?.customization == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday == undefined ||
				this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarTelefone) {

				var campoT = {
					variableName: "telefone",
					fieldType: "TextFieldMask",
					label: "Telefone",
					type: "text",
					cols: "12",
					maskFormat: "(##) #####-####",
					required: true
				};
				this.fields.push(campoT);
			}
		},

		methods: {
			...mapMutations(["SET_RECEBER_LIGACAO", "SET_EMPRESAS"]),

			...mapMutationsPassosRetornarDividas(["SET_EMAIL_INVALIDO", "SET_TELEFONE_INVALIDO", "SET_ENDERECO_INVALIDO"]),

			...mapActionsPassosRetornarDividas(["acaoPasso1ConsultarCpf"]),

			...mapActions(["action_atualizar_data_nascimento"]),

			dadosValidos() {
				if (this.parceiroConfig.sessoes?.customization == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarDataNasc)
					if (this.inputsValues.nascimento == "") {
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Por favor",
							message: `Insira uma data de nascimento válida.`,
							styleMessage: "danger"
						});
						return false;
					}

				if (this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarTelefone)
					if (this.inputsValues.telefone == "" || this.inputsValues.telefone.length <= 13) {
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Por favor",
							message: `Insira um telefone válido.`,
							styleMessage: "danger"
						});
						return false;
					}

				return true;
			},

			receberCPFCNPJ() {
				this.action_salvar_etapa({
					cpfCnpj: this.removeMaskCharacters(this.identification),
					esn_fk_ets_codigo: 8,
					emp_codigo: this.parceiroConfig.emp_codigo
				});

				this.acaoPasso1ConsultarCpf({
					pesCpfCnpj: this.removeMaskCharacters(this.identification)
				}).then(resposta => {

					if (resposta.data.retorno) {

						if (resposta.data.dados == null) {
							this.$router.push({
								name: "Register",
								params: {
									identification: this.removeMaskCharacters(this.identification)
								}
							});
							return -1;

						} else if (resposta.data.dados) {
							this.SET_RECEBER_LIGACAO(false);

							this.SET_EMAIL_INVALIDO(resposta.data.dados.pes_email == '');
							this.SET_TELEFONE_INVALIDO(resposta.data.dados.pef_fone[0] == '');
							this.SET_ENDERECO_INVALIDO(resposta.data.dados.pessoa_endereco.pee_cep == null);

							if (this.parceiroConfig.sessoes?.customization == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday == undefined ||
								this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarToken && this.parceiroConfig.identificador === "Senff") {

								this.$router.push({
									name: "VerifyToken",
									params: {
										fone: this.inputsValues.telefone
									}
								});
								this.SET_LOADING_MESSAGE("");
								this.SET_LOADING(false);

							} else if (this.parceiroConfig.sessoes?.customization?.campos?.menuDebits?.flgPrefeituraMode || this.parceiroConfig.identificador === "Senff") {
								this.$router.push({ name: "MyDebits" });

							} else {
								this.$router.push({ name: "AccordionTabs" });
								this.SET_LOADING_MESSAGE("");
								this.SET_LOADING(false);
							}
						}

					} else if (!resposta.data.retorno && !resposta.data?.dados) {
						this.SET_LOADING(false);
						this.SET_LOADING_MESSAGE("");

						if (resposta.data.mensagem == "Erro ao consultar o usuário! 1") {
							this.CHANGE_MESSAGE_MODAL({
								show: true,
								title: "Data de nascimento incorreta",
								message: `Data de nascimento informada não condiz com a data do seu cadastro.`,
								styleMessage: "danger"
							});
							return -1;

						} else if (resposta.data.mensagem == "Erro ao consultar o usuário! 2") {
							this.CHANGE_MESSAGE_MODAL({
								show: true,
								title: "Telefone incorreto",
								message: `Telefone informada não condiz com o telefone do seu cadastro.`,
								styleMessage: "danger"
							});
							return -1;

						} else {

							this.CHANGE_MESSAGE_MODAL({
								show: true,
								title: "Usuario não encontrado",
								message: `Você não possui nenhuma dívida ou acordo cadastrado em nosso banco de dados. Para maiores informações entre em contato conosco pelo telefone 0800 3121003, ou pelo WhatsApp <a href="https://api.whatsapp.com/send?phone=4831210258" target="_blank">48 3121 0258</a>, ou ainda pelo e-mail: <a href="mailto:contato@mercobran.com.br">contato@mercobran.com.br</a>`,
								styleMessage: "danger"
							});
							return -1;
						}

					} else if (resposta.data.retorno && (resposta.data.dados === "CPF/CNPJ não encontrado!" || resposta.data.dados === null)) {
						this.SET_LOADING(false);
						this.SET_LOADING_MESSAGE("");

						if (this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgDesativaCadastro) {
							this.CHANGE_MESSAGE_MODAL({
								show: true,
								title: "Usuario não encontrado",
								message: `Você não possui nenhuma dívida ou acordo cadastrado em nosso banco de dados. Para maiores informações entre em contato conosco pelo telefone 0800 3121003, ou pelo WhatsApp <a href="https://api.whatsapp.com/send?phone=4831210258" target="_blank">48 3121 0258</a>, ou ainda pelo e-mail: <a href="mailto:contato@mercobran.com.br">contato@mercobran.com.br</a>`,
								styleMessage: "danger"
							});

						} else {
							this.$router.push({
								name: "Register",
								params: {
									identification: this.removeMaskCharacters(this.identification)
								}
							});
						}

					} else {
						this.SET_LOADING_MESSAGE("");
						this.SET_LOADING(false);
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Erro",
							message: `Ocorreu um erro ao tentar encontrar o seu CPF`,
							styleMessage: "danger"
						});
						return -1;
					}

				}).catch(_ => {
					this.SET_LOADING_MESSAGE("");
					this.SET_LOADING(false);
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Erro",
						message: "Não foi possível achar seu CPF em nossos registros!",
						styleMessage: "danger"
					});
				});
			},

			next() {

				if (!this.dadosValidos()) {
					return -1;
				}

				if (this.verified) {
					this.SET_LOADING(true);
					this.SET_LOADING_MESSAGE("Confirmando os seus dados");
					this.receberCPFCNPJ();

				} else {
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Por favor",
						message: `Conclua a verificação de segurança`,
						styleMessage: "danger"
					});
					return -1;
				}
			},

			esqueceu() {
				this.SET_LOADING(true);
				this.SET_LOADING_MESSAGE("Confirmando sua data de nascimento");
				this.$router.push({
					name: "ResetPhone",
					params: {
						identification: this.removeMaskCharacters(this.identification)
					}
				});

				this.SET_LOADING_MESSAGE("");
				this.SET_LOADING(false);
			}
		}
	};
</script>

<style scoped lang="scss">
	.page-birthday {
		min-height: 100vh;
		flex: 1;
		padding: 50px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.page-birthday h3 {
		text-align: center;
		color: var(--secondaryColor);
		font-size: 32px;
		font-family: Montserrat-Bold;
		margin-bottom: 5px;
	}

	.page-birthday p {
		text-align: center;
		font-size: 14px;
		line-height: 24px;
		font-family: Roboto;
		font-weight: normal !important;
		margin-bottom: 30px;
	}

	.box-login {
		width: 400px;
	}

	.vue-recaptcha {
		align-items: center;
		justify-content: center;
		display: flex;
	}

	.box-buttons {
		display: flex;
		flex-direction: column;
		margin-top: 30px;
		padding: 0 15px;
		gap: 20px;
	}

	#userAgreement {
		display: flex;
		align-items: center;

		input {
			background-color: #c9c9c9;
			border: 2px solid #bbbbbb;
			border-radius: 40px;
			border-bottom-color: transparent;
			border-left-color: transparent;
			height: 40px;
			left: -4px;
			outline: 0;
			top: -4px;
			width: 40px;
			box-sizing: border-box;
			animation: spinner-spin linear 2.5s infinite;
			animation-play-state: paused;
			transition-duration: 1s;
			margin-right: 6px;
		}
	}

	@media only screen and (max-width: 768px) {
		.page-birthday {
			align-items: flex-start;
		}
	}

	input {
		margin: 5px 0;
		height: 46px;
		border-radius: 10px;
		background: var(--whiteColor);
		padding: 0 10px;
		border: 1px solid #878785 !important;
		color: #1d1d1b;
		font-family: "Roboto Black";
		font-size: 16px;
	}

	.text-opacity {
		opacity: 0.7;
	}

	input.solid-color {
		background: var(--whiteColor);
	}

	input.border-default,
	input.has-value {
		border: 0;
	}

	input.border-red {
		border: thin solid var(--dangerColor);
	}
</style>
